module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overflow-x-auto mx-4 mb-5",
    attrs: {
      "id": "taps-summary"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "w-full flex justify-center items-center h-72"
  }, [_c('pl-spinner')], 1) : _c('div', [(_vm.tapsData.length !== 0) ? _c('div', [_c('table', {
    staticClass: "table-auto min-w-full"
  }, [_c('thead'), _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left px-2 py-2 border-b bg-white text-blueGray-800 select-none"
  }, [_vm._v("Turn Type")]), _vm._v(" "), _vm._l((_vm.tapsData), function(data, index) {
    return _c('th', {
      key: index,
      staticClass: "text-center px-3 py-2 border-b cursor-pointer hover:underline bg-white"
    }, [_c('Popper', {
      attrs: {
        "append-to-body": true,
        "prevent-default": true,
        "trigger": "hover",
        "options": {
          placement: 'top',
        }
      }
    }, [_c('div', {
      staticClass: "popper bg-white rounded-md shadow-sm relative"
    }, [_c('div', {
      staticClass: "flex items-center space-x-2 px-3 py-2"
    }, [_c('div', {
      staticClass: "h-5 w-5 bg-green-dark rounded-full flex items-center justify-center"
    }, [_c('img', {
      staticClass: "w-2.5 h-2.5",
      attrs: {
        "src": "/static/roundtable_icons/verbal_icon.svg"
      }
    })]), _vm._v(" "), _c('h6', {
      staticClass: "text-blueGray-800 text-xs font-poppins"
    }, [_vm._v(_vm._s(data.live_discussion))])])]), _vm._v(" "), _c('button', {
      staticClass: "h-full items-center font-semibold hover:underline font-poppins text-blueGray-800",
      attrs: {
        "slot": "reference"
      },
      on: {
        "click": function($event) {
          return _vm.handleGoRT(data.live_discussion_id)
        }
      },
      slot: "reference"
    }, [_vm._v("\n                    RT " + _vm._s(index + 1) + "\n                  ")])])], 1)
  })], 2)]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "border-b py-1.5 px-2 font-poppins font-light"
  }, [_vm._v("New Idea")]), _vm._v(" "), _vm._l((_vm.tapsData), function(data, index) {
    return _c('td', {
      key: index,
      staticClass: "text-left px-3 py-2 border-b bg-white"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('div', {
      staticClass: "w-8 h-8 flex items-center text-white justify-center select-none text-base font-poppins font-semibold rounded",
      class: {
        'bg-blueGray-300': data.new_idea === 0,
        'bg-primary bg-opacity-20': data.new_idea === 1,
        'bg-primary bg-opacity-40': data.new_idea === 2,
        'bg-primary bg-opacity-60': data.new_idea === 3,
        'bg-primary bg-opacity-80': data.new_idea === 4,
        'bg-primary': data.new_idea > 4,
      }
    }, [_c('span', [_vm._v(_vm._s(data.new_idea === 0 ? '-' : data.new_idea))])])])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-b py-1.5 px-2 font-poppins font-light"
  }, [_vm._v("Build On")]), _vm._v(" "), _vm._l((_vm.tapsData), function(data, index) {
    return _c('td', {
      key: index,
      staticClass: "text-left px-3 py-2 border-b bg-white"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('div', {
      staticClass: "w-8 h-8 flex items-center text-white justify-center select-none text-base font-poppins font-semibold rounded",
      class: {
        'bg-gray-300': data.build_on === 0,
        'bg-green-700 bg-opacity-20': data.build_on === 1,
        'bg-green-700 bg-opacity-40': data.build_on === 2,
        'bg-green-700 bg-opacity-60': data.build_on === 3,
        'bg-green-700 bg-opacity-80': data.build_on === 4,
        'bg-green-700': data.build_on > 4,
      }
    }, [_c('span', [_vm._v(_vm._s(data.build_on === 0 ? '-' : data.build_on))])])])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-b py-1.5 px-2 font-poppins font-light"
  }, [_vm._v("Challenge")]), _vm._v(" "), _vm._l((_vm.tapsData), function(data, index) {
    return _c('td', {
      key: index,
      staticClass: "text-left px-3 py-2 border-b bg-white"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('div', {
      staticClass: "w-8 h-8 flex items-center text-white justify-center select-none text-base font-poppins font-semibold rounded",
      class: {
        'bg-gray-300': data.challenge === 0,
        'bg-pinky bg-opacity-20': data.challenge === 1,
        'bg-pinky bg-opacity-40': data.challenge === 2,
        'bg-pinky bg-opacity-60': data.challenge === 3,
        'bg-pinky bg-opacity-80': data.challenge === 4,
        'bg-pinky': data.challenge > 4,
      }
    }, [_c('span', [_vm._v(_vm._s(data.challenge === 0 ? '-' : data.challenge))])])])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-b py-1.5 px-2 font-poppins font-light"
  }, [_vm._v("Question")]), _vm._v(" "), _vm._l((_vm.tapsData), function(data, index) {
    return _c('td', {
      key: index,
      staticClass: "text-left px-3 py-2 border-b bg-white"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('div', {
      staticClass: "w-8 h-8 flex items-center text-white justify-center select-none text-base font-poppins font-semibold rounded",
      class: {
        'bg-gray-300': data.question === 0,
        'bg-blueGray-300': data.question === 1,
        'bg-blueGray-400': data.question === 2,
        'bg-blueGray-500': data.question === 3,
        'bg-blueGray-600': data.question === 4,
        'bg-blueGray-800': data.question > 4,
      }
    }, [_c('span', [_vm._v(_vm._s(data.question === 0 ? '-' : data.question))])])])])
  })], 2), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-b py-1.5 px-2 font-poppins font-light"
  }, [_vm._v("By Teacher")]), _vm._v(" "), _vm._l((_vm.tapsData), function(data, index) {
    return _c('td', {
      key: index,
      staticClass: "text-left px-3 py-2 border-b bg-white"
    }, [_c('div', {
      staticClass: "flex justify-center items-center"
    }, [_c('div', {
      staticClass: "w-8 h-8 flex items-center text-white justify-center select-none text-base font-poppins font-semibold rounded",
      class: {
        'bg-gray-300': data.hand_raise === 0,
        'bg-orange bg-opacity-20': data.hand_raise === 1,
        'bg-orange bg-opacity-40': data.hand_raise === 2,
        'bg-orange bg-opacity-60': data.hand_raise === 3,
        'bg-orange bg-opacity-80': data.hand_raise === 4,
        'bg-orange': data.hand_raise > 4,
      }
    }, [_c('span', [_vm._v(_vm._s(data.hand_raise === 0 ? '-' : data.hand_raise))])])])])
  })], 2)])])]) : _c('div', {
    staticClass: "w-full flex justify-center items-center h-72"
  }, [_c('span', {
    staticClass: "font-poppins text-blueGray-800"
  }, [_vm._v("No data to display")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0496989e!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/pages/Reports/VerbalCharts/TapsSummary.vue
// module id = 2280
// module chunks = 61